/* import __COLOCATED_TEMPLATE__ from './back-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();